import { Grid } from "@mui/material";
import React from "react";
import { AutocompleteInput, Create, DateTimeInput, SelectInput, TextInput, required } from "react-admin";
import { CountryEnum, StatusEnum } from "src/common/enum";
import { FileInput } from "src/components/file-input";
import { PhoneInput, StateInput } from "src/components/input";
import { FormTab, TabbedForm } from "src/enterprise/ra-rbac";
import { GroupCreateComponent } from ".";

export const GroupCreate = () => {
  return (
    <Create component={GroupCreateComponent}>
      <TabbedForm>
      <FormTab label="General" name="general">
        <Grid container rowSpacing={1} columnSpacing={2}>
        <Grid item lg={4} sm={12}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item lg={6} sm={12}>
            <TextInput source="email" validate={required()} />
          </Grid>
          <Grid item lg={6} sm={12}>
            <PhoneInput source="phone" label="Phone" validate={required()}/>
          </Grid>
          <Grid item lg={6} sm={12}>
            <PhoneInput source="mobile" label="Mobile"  />
          </Grid>
          <Grid item lg={6} sm={12}>
            <TextInput source="website"  />
          </Grid>
          <Grid item lg={6} sm={12}>
            <SelectInput source="status" choices={StatusEnum} validate={required()} />
          </Grid>
          <Grid item sm={12}>
            <FileInput
                label="Resale File"
                source="resaleFile"
                multiple={false}
                fileTypes={["PDF", "DOCX"]}
                inputType="document"
                previewWidth={"fit-content(40%)"}
            />
          </Grid>
          <Grid item lg={6} sm={12}>
            <TextInput source="resaleNumber" />
          </Grid>
          <Grid item lg={6} sm={12}>
            <DateTimeInput source="resaleDateEstablished" />
          </Grid>


        </Grid>
        </FormTab>


        <FormTab label="Address" name="general">
          <Grid container rowSpacing={1} columnSpacing={2}>

            <Grid item sm={12} lg={4}>
              <TextInput source="streetAddress" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={4}>
              <TextInput source="city" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={4}>
              <TextInput source="zip" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={6}>
              <AutocompleteInput
                source="country"
                size="small"
                choices={CountryEnum.slice(1)}
                sx={{
                  "#state": { width: "100%" },
                }}
                emptyValue={""}
                validate={required()}
              />
            </Grid>
            <Grid item sm={12} lg={6}>
              <StateInput />
            </Grid>
            
          </Grid>
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
